import { Checkbox as MUICheckbox } from '@mui/material';
import { CheckboxProps } from '@mui/material/Checkbox/Checkbox';
import { FunctionComponent } from 'react';
import { ColorPalette } from 'shared/consts/colorPalette';
import { Icon } from 'shared/ui/Icon';

export const Checkbox: FunctionComponent<CheckboxProps> = ({ sx, onClick, ...props }) => {
	const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		event.stopPropagation();
		if (onClick) {
			onClick(event);
		}
	};

	return (
		<MUICheckbox
			sx={{
				width: '20px',
				height: '20px',
				padding: '0',
				color: props.checked ? ColorPalette.royalBlue : ColorPalette.rockBlue,
				...sx,
			}}
			icon={<Icon id={'custom_checkbox'} />}
			checkedIcon={<Icon id={'custom_checkbox_checked'} />}
			onClick={handleClick}
			{...props}
		/>
	);
};
